import { useReactiveVar } from "@apollo/client";
import { Tabs, TabsProps } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import { Colors } from "../../../constants/Colors";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import ChannelTabContent from "./channelTabContent";
import { fetchChannelTabs } from "./services/channel.services";
import "./channel.scss";

interface ChannelProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

interface ChannelTab {
  channelId: number;
  channelName: string;
}

const Channel = ({
  setSelectedService,
  setSelectSubItem,
}: ChannelProps) => {
  const currentUser = useReactiveVar(__currentUser__);
  const userName = currentUser?.userName || "";
  const [items, setItems] = useState<TabsProps["items"]>([]);

  const getTabs = async () => {
    const result = await fetchChannelTabs();

    if (result?.data) {
      const tabs = result.data;

      const tabItems: TabsProps["items"] = tabs.map(
        (tab: ChannelTab, index: number) => ({
          key: index,
          label: tab.channelName,
          children:
            <ChannelTabContent
              channelId={tab.channelId}
              channelName={tab.channelName}
              userName={userName}
            />,
        })
      );

      setItems(tabItems);
    }
  };

  const {
    data: userPrograms,
    loading: userProgramsLoading,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 10,
    },
  });

  useEffect(() => {
    setSelectedService(ServiceTypes.ZIPPY_AND_ME);
    setSelectSubItem("Channel");
    getTabs();
  }, []);


  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Channel"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="channelWrapper">
      <div className="header" style={{ backgroundColor: Colors.white }}>
        <p className="header-title" style={{ color: Colors.darkGrey }}>
          Channel
        </p>
      </div>
      {items && items.length > 0 &&
        <Tabs
          items={items}
          size="small"
          tabBarStyle={{
            paddingLeft: 24,
            backgroundColor: Colors.white,
            height: 50,
          }}
        />
      }
    </div>
  );
};

export default Channel;
